<template>
  <div class="d-flex status__icons">
    <span
      v-for="icon in preparedIcons"
      :key="icon.key+icon.class"
      :class="['status-icon', 'mx-1', 'text-' + icon.class]"
      :title="icon.text"
    >
      <font-awesome-icon :icon="icon.key" />
    </span>
  </div>
</template>

<script>
export default {
  name: "LeadStatusIcons",
  props: ['statusIcons', 'archived'],
  data: function() {
    return {
      preparedIcons: [],
    }
  },
  methods: {
    prepareIcons: function() {
      let rejected = this.isReportRejected();
      let accepted = this.isReportAccepted();
      let appealed = this.isAppealed();
      let reported = this.isReported();
      if ((!accepted && !appealed && !reported) || (rejected)) {
        this.preparedIcons.push({key:'circle', text:"Valid", class:"success"});
      }
      this.isExtended();
      if (this.archived) {
        this.preparedIcons.push({key:'archive', text: "Archived", class:"info"});
      }
    },
    isReported: function() {
      if (this.statusIcons.find((icon) => icon.class === 'icon-reported') !== undefined
        && this.statusIcons.find((icon) => icon.class === 'icon-report-rejected') === undefined
        && this.statusIcons.find((icon) => icon.class === 'icon-report-accepted') === undefined
      ) {
        this.preparedIcons.push({key:'circle', text:"Reported", class:"danger"});
        return true;
      }
      return false;
    },
    isAppealed: function() {
      if (this.statusIcons.find((icon) => icon.class === 'icon-report-appealed') !== undefined) {
        this.preparedIcons.push({key:'circle', text:"Appealed", class:"warning"});
        return true;
      }
      return false;
    },
    isReportAccepted: function() {
      if (this.statusIcons.find((icon) => icon.class === 'icon-report-accepted') !== undefined) {
        this.preparedIcons.push({key:'times-circle', text:"Invalid", class:"danger"});
        this.preparedIcons.push({key:'thumbs-up', text:"Report Accepted", class:"success"});
        return true;
      }
      return false;
    },
    isReportRejected: function() {
      if (this.statusIcons.find((icon) => icon.class === 'icon-report-rejected') !== undefined) {
        this.preparedIcons.push({key:'thumbs-down', text:"Report Rejected", class:"danger"});
        return true;
      }
      return false;
    },
    isExtended: function() {
      if (this.statusIcons.find((icon) => icon.class === 'icon-report-extended') !== undefined) {
        this.preparedIcons.push({key:'hourglass-half', text:"Time extended", class:"warning"});
        return true;
      }
      return false;
    }
  },
  created: function() {
    this.prepareIcons();
  }
}
</script>

<style scoped lang="scss">
.status__icons {
  font-size: $h5-font-size;
}
</style>
